import { render, staticRenderFns } from "./OverlayPage.vue?vue&type=template&id=ceab9a62&scoped=true"
import script from "./OverlayPage.vue.ts?vue&type=script&lang=ts&external"
export * from "./OverlayPage.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./OverlayPage.vue?vue&type=style&index=0&id=ceab9a62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceab9a62",
  null
  
)

export default component.exports